import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { OrderWindow } from '../../../../models/order-window.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-buying-window-item',
  templateUrl: './buying-window-item.component.html',
  styleUrls: ['./buying-window-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class BuyingWindowItemComponent {
  @Input() orderWindow: OrderWindow;
  @Output() onNavigate = new EventEmitter();

  constructor(private router: Router) {}

  get hasMerketDates(): boolean {
    return (
      !!this.orderWindow.market_start_at && !!this.orderWindow.market_end_at
    );
  }

  get programLinkLabel(): string {
    if (this.orderWindow.active) {
      return 'VIEW ALL PROGRAMS';
    }

    if (this.orderWindow.upcoming) {
      return 'View upcoming programs';
    }

    return 'View historic programs';
  }

  get badgeLabel(): string {
    if (this.orderWindow.active) {
      return 'OPEN';
    }

    if (this.orderWindow.upcoming) {
      return 'UPCOMING';
    }

    return 'CLOSED';
  }

  get badgeClass(): string {
    if (this.orderWindow.active) {
      return 'open';
    }

    if (this.orderWindow.upcoming) {
      return 'upcoming';
    }

    return 'closed';
  }
  handleNavigate() {
    this.onNavigate.emit();
    this.router.navigate(['/buying-window', this.orderWindow.id, 'programs']);

    // this.orderService.switchActiveOrderWindow$(this.orderWindow).subscribe(() => {
    //   this.router.navigate([`/buying-window/${this.orderWindow.id}/programs`]);
    // });
  }

  get canNavigate(): boolean {
    if (this.orderWindow.upcoming) {
      return this.orderWindow.programs_count > 0;
    }
    return true;
  }
}
